/**
 * intl-latam-ec-portal-documents
 * No description
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CompanyDocumentModel } from './companyDocument';
import { PersonPolicyContactsModel } from './personPolicyContacts';


export class BrokerManagerPersonModel { 
    id?: number;
    firstName?: string;
    lastName?: string;
    secondLastName?: string;
    secondName?: string;
    contacts?: PersonPolicyContactsModel;
    document?: CompanyDocumentModel;
    constructor(){
        this.contacts= new PersonPolicyContactsModel();
        this.document = {
          "documentNumber": null,
          "type": {
            "id": 2,
            "code": "R.U",
            "description": "Registro único de contribuyente"
          }
        }
    }
}
